export default "__VITE_ASSET__BNj8BHky__"